import {
  Briefcase,
  HeartPulse,
  Building2,
  CalendarDays,
  Warehouse,
  Sparkles,
  ShieldCheck,
  ClipboardList,
  Users,
} from "lucide-react";

export const SERVICE_ICONS = {
  Briefcase,
  HeartPulse,
  Building2,
  CalendarDays,
  Warehouse,
  Sparkles,
  ShieldCheck,
  ClipboardList,
  Users,
};

export const serviceIcon = (name) => SERVICE_ICONS[name] || Briefcase;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -88 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const DEFAULT_HERO_IMAGE =
  "https://images.pexels.com/photos/8353820/pexels-photo-8353820.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
